export const vowelCheck = letter => /^[aeiou]$/i.test(letter);

export const truncateText = (text, max) => {
  if (!text) return '';

  return text.length > max ? text.slice(0, max).trim() + '...' : text;
};

export const truncateAroundWords = (text, max) => {
  if (text.length < max + 10) return text;

  const truncatedText = text.slice(0, max).split(' ');

  return truncatedText.slice(0, truncatedText.length).join(' ') + '...';
};

export const parseHtml = html => {
  const div = document.createElement('div');
  div.innerHTML = html;
  const styleEl = div.querySelector('style');
  if (styleEl) styleEl.remove();
  return div.textContent || div.innerText || '';
};

export const formatPriceToString = number => {
  const numArray = String(number).split('.');
  if (numArray.length === 1) {
    return numArray[0] + '.00';
  } else {
    if (numArray[1].length === 1) {
      return String(number) + '0';
    } else {
      return numArray[0] + '.' + numArray[1].slice(0, 2);
    }
  }
};

export const formatPhoneNumber = phoneNumberString => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match && match.slice(1, 4).join('').length === 10) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return phoneNumberString;
};

export const formatToPercentage = number => {
  if (!number) return 'N/A';

  return `${number}%`;
};

export const dollarSignify = string =>
  string &&
  string
    .replaceAll('USD', '')
    .replaceAll(',', '')
    .replaceAll(/\d+/g, n => {
      return '$' + parseInt(n).toLocaleString('en-US');
    });
